// Offline Mode Configuration
export const offlineConfig = {
  // Check if offline mode is enabled via environment variable
  isOfflineMode: process.env.VUE_APP_OFFLINE_MODE === "true",
  bypassAuth: process.env.VUE_APP_BYPASS_AUTH === "true",
  disableSSL: process.env.VUE_APP_DISABLE_SSL === "true",
  useMockData: process.env.VUE_APP_USE_MOCK_DATA === "true",
};

export default offlineConfig;
